import queryString from 'query-string'
import { isEmpty } from '../assertion'

export type AdminGodParams = {
  iid?: string
  uid?: string
}

export type AdminGodOptions = {
  institutionIdByAdmin?: string
  userIdByAdmin?: string
}

export type AdminGodOptionsWithParams = {
  options: AdminGodOptions
  params: AdminGodParams
}

export type GodModeState = AdminGodOptionsWithParams & {
  inGodMode: boolean
}

export const getGodModeFields = (): AdminGodOptionsWithParams => {
  const params = queryString.parse(window.location.search) as AdminGodParams
  const options: AdminGodOptions = {}

  if (params.iid) {
    options.institutionIdByAdmin = params.iid
  } else if (params.uid) {
    options.userIdByAdmin = params.uid
  }

  return { options, params }
}

export const getGodModeOptionsState = (
  institutionId?: string
): GodModeState => {
  const fields = getGodModeFields()

  if (institutionId) {
    fields.options.institutionIdByAdmin = institutionId
    fields.params.iid = institutionId
    delete fields.options.userIdByAdmin
    delete fields.params.uid
  }

  return {
    inGodMode: !isEmpty(fields.options) && !isEmpty(fields.params),
    ...fields
  }
}

export const getGodModeURLSuffix = (institutionId?: string): string => {
  const state = getGodModeOptionsState()

  if (state.options.institutionIdByAdmin) {
    return `?iid=${state.options.institutionIdByAdmin}`
  } else if (institutionId) {
    return `?iid=${institutionId}`
  } else if (state.options.userIdByAdmin) {
    return `?uid=${state.options.userIdByAdmin}`
  }

  return ''
}
